import React, { useContext, useEffect, useRef, useState } from "react";
import { get } from "../../../../logics/src/utils/helpers";
import { SavedPaymentView } from "layouts/SavedPayment";
import { NewPaymentDetails } from "layouts/CheckoutPayment/mobile/NewPaymentDetails";
import { Main } from "pages/Payment/assets/style";
import { MorePaymentMethod } from "layouts/CheckoutPayment/mobile/AllSavedPaymentMethod/MorePaymentMethod";
import { ShippingAddress } from "layouts/CheckoutPayment/mobile/ShippingAddress";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { default as WalletMultiModal } from "layouts/Payment/WalletMultimodal";
import { getStringFromId } from "../../../../helpers/vernacular";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { checkIsExperimentEligible } from "helpers/utils/isExperimentEligible";
import { PlaceOrderButton } from "./PlaceOrderButton";
import { PAYMENT_OPTION, PAYMENT_SCREENS } from "constants/paymentScreens";
import { useHistory } from "react-router-dom";
import {
  checkIsAddressIdDelCookiePresent,
  getPaymentOffers,
} from "layouts/Payment/common/dependencies/dependencyhelpers";
import { AddressNotMatchedMessageCard } from "../AddressNotMatchedMessageCard";
import { DeliveryToast } from "../DeliveryToast";
import { getIsSavedMethodsDisplayed } from "wrapper/PaymentWrapper/dependencies/helper";
import { useTheme } from "emotion-theming";
import { UserContext } from "wrapper/UserWrapper/context";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { ErrorModalContext } from "wrapper/ErrorModalWrapper/context";
import { VerifyOtpContext } from "wrapper/VerifyOtpWrapper/context";
import { setCheckoutSuccessToFalseInDataLayer, trackPayNowClick } from "layouts/Payment/common/dependencies/tracking";
import { doPaymentHandler } from "layouts/Payment/logics/doPaymentHandler";
import { windowScrollToTop } from "helpers/utils/scrollTop";
import { getSavedOffer } from "../../../../logics/src/utils/checkOffers";
import { usePriceDetailsConfig } from "../../../../hooks/usePriceDetailsConfig";
import {
  trackInfoIconClick,
  trackPaymentDetailClick,
} from "layouts/Payment/common/dependencies/tracking";
import { borderRadius, noMargin } from "../NewPaymentDetails/assets/borderRadius";
import { getPlatform } from "../../../../helpers";
import { localStorageService } from "service/storage";
import { PAYMENT_MODES } from "constants/paymentModes";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import { PAGE_NAMES, PAGE_TYPES, TRACKING_EVENTS } from "constants/index";
import { getBucketSize } from "helpers/utils/getBucketSize";
import { checkIsNewPaymentMethodVisibleOnScreen1, getAvailablePaymentMethodOnSavedPaymentScreen, checkAllUpiIntentVisibilityOnWeb, getCodAvailableAttributes } from "layouts/CheckoutPayment/helpers";
import { trackPayment1PageLoad } from "layouts/Payment/common/dependencies/tracking";
import { NO_SAVED_METHOD } from "constants/dataLayer";
import { useEddConfig } from "hooks/useEdd";
import DeliveryEstimate from "../EstimateDelivery";
import { CircularLoader } from "@nykaa/payment-ui/src/CircularLoader";
import { ShippingAddressContent } from "../ShippingAddress/assets/style";
import { getStorageData } from "helpers/utils/storage";
import { PAYTM_AUTOPAY } from "constants/cookies";
import {
  allTrackingHandlerForApps,
  getRetinaPayment1LoadData,
  triggerRetinaEventForWeb,
} from "helpers/utils/trackingHandler";
import { MainLoaderLoayoutWrapper } from "layouts/CheckoutPayment/assets/style";
import { ZEST_MONEY_EXPERIMENT } from "layouts/Payment/common/dependencies/constants";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { NewPaymentFailureFlow } from "layouts/PaymentFailure/NewPaymentFailureFlow";
import { SavedPaymentWrapper } from "layouts/SavedPayment/assets/style";
import PaymentView from "layouts/Payment/Loadable";
import { ErrorBoundary } from "components/ErrorBoundary";
import { CommonContextContext } from "wrapper/CommonWrapper/context";
import { DiscountInfoStrip } from "components/DiscountInfoStrip";
import { RetryWalletTile } from "components/RetryWalletTile";
import PaymentOffers from "layouts/PaymentOffers/Loadable";


interface IAllSavedPaymentMethod {
  isVisible: boolean;
  setIsWalletChecked: any;
  setPaymentScreen: any;
  timerCallback: any;
  setUpiDetails: any;
  isGPayIntentAvailable: boolean;
  loading: boolean;
  showAllPaymentMethods: boolean;
  showFallbackModeSheet: boolean;
  setShowFallbackModeSheet: (value: boolean)=>void;
  isGPayIntentLoading: boolean;
}

const AllSavedPaymentMethod = ({
  isVisible,
  setIsWalletChecked,
  setPaymentScreen,
  timerCallback,
  setUpiDetails,
  isGPayIntentAvailable,
  loading,
  showAllPaymentMethods,
  showFallbackModeSheet,
  setShowFallbackModeSheet,
  isGPayIntentLoading
}: IAllSavedPaymentMethod) => {
  const history = useHistory();
  const platform = getPlatform();
  const [addressIdNotSame, setAddressIdNotSame] = useState("");
  /* We are fetching ADDRESS_ID_NOT_SAME from localStorage in checkout page to show the toaster for edd
  We are removing from localStorage after showing toast for one time
  */
  useEffect(() => {
    setAddressIdNotSame(localStorageService.getItem("ADDRESS_ID_NOT_SAME") || "");
    if (localStorageService.getItem("ADDRESS_ID_NOT_SAME")) {
      localStorageService.removeItem("ADDRESS_ID_NOT_SAME");
    }
  }, []);
  const theme: Theme = useTheme();
  const paymentContext = useContext(PaymentContext);
  const { userData } = useContext(UserContext);
  const { applicationData } = useContext(ApplicationContext);
  const errorModalContext = useContext(ErrorModalContext);
  const {
    EDD,
    NewPaymentFailure,
    NewPaymentMethodOnPaymentScreen1,
    UpiIntentMweb,
    DiscountInfoStripExp,
    NewAddressDesignExp,
    PaymentOfferRevamp,
    ConvenienceCharges,
  } = useContext(ExperimentAndSwitchContext);
  const {
    setIsVerifyOtpVisible,
    isOtpVerificationRequired,
    handleCallBackAfterVerification,
  } = useContext(VerifyOtpContext);
  const {
    commonData: { isFirstLandingPageAfterCheckout },
    setIsFirstLandingPageAfterCheckout,
  } = useContext(CommonContextContext);
  const walletConfig = paymentContext?.walletConfig;
  const giftCardConfig = paymentContext?.giftCardInfoConfig;
  const orderAmount = paymentContext?.orderAmount;

  const cartInfo = get(paymentContext, "cartInfo");
  const paymentInfo = get(paymentContext, "paymentInfo");
  const upiIntentList = get(paymentContext, "upiIntentList");

  const cartErrorMessage = get(paymentContext, "cartInfo.cartErrorMessage");
  const grandTotal = get(cartInfo, "grandTotal");
  const walletBalance = get(walletConfig, "walletBalance");
  const isFullPaymentByGiftCard = get(giftCardConfig, "isFullPaymentByGiftCard");
  const offersData: any = get(paymentContext, "offersData");
  const { isGuest } = userData;
  const flow = get(paymentContext, "flow");
  const flowConfig = get(paymentContext, "flowConfig");
  const { deviceType, isApp } = applicationData;
  const openErrorModal = get(errorModalContext, "openErrorModal");
  const setLoading = get(paymentContext, "setLoading");
  const doPaymentApi = get(paymentContext, "doPaymentApi");
  const walletInfo = get(paymentContext, "walletInfo");
  const products = get(cartInfo, "items");
  const isPaymentInfoLoading = paymentContext?.isPaymentInfoLoading;
  // const [showSavedOffers, setShowSavedOffers] = ueState(true);
  const setIsAutoCreateOrderLoading = get(paymentContext, "setIsAutoCreateOrderLoading");
  const query = new URLSearchParams(history.location.search);
  const autoCreateOrder = query.get("autoCreateOrder"); // Getting autoCreateOrder as string from queryParams
  const payTmAutoPay = getStorageData(PAYTM_AUTOPAY, false) || "false"; // Getting payTmAutoPay as string from session storage
  const autoPayTmCreateOrder = autoCreateOrder === "true" && payTmAutoPay === "true";
  const visibleOfferBottomSheet = paymentContext?.visibleOfferBottomSheet;
  const setVisibleOfferBottomSheet = paymentContext?.setVisibleOfferBottomSheet;
  // used for hiding circular loader in paymentFailureFlow
  const failureFlowEnabled = NewPaymentFailure?.switchEnabled && NewPaymentFailure?.experimentEnabled;
  const isNewAddressDesignEnabled = NewAddressDesignExp?.switchEnabled && NewAddressDesignExp?.experimentEnabled;
  const isFailureUrl = failureFlowEnabled && window?.location?.href?.includes("paymentFailureOrderId");
  const isSavedPayment = get(paymentContext, "paymentResponseV2Data.isSavedPayment");
  const paymentScreen = get(paymentContext, "paymentScreen");
  const codHandlingCharge = paymentContext?.codHandlingCharge;
  const isCodMethodSelected = paymentContext?.isCodMethodSelected;
  const setPaymentOption = paymentContext?.setPaymentOption;
  const showRetryWalletTile = paymentContext?.showRetryWalletTile;
  const isRetryWalletExpEnabled = paymentContext?.isRetryWalletExpEnabled;
  const handleRetryWalletClick = paymentContext?.handleRetryWalletClick;
  const availablePaymentMethods = get(cartInfo, "availablePaymentMethods");
  const isCodAvailable = cartInfo?.isCodAvailable;
  const cashFreePaymentGateway = get(cartInfo, "paymentGateway");
  const totalSaved = Math.round(get(cartInfo, "totalSaved"));
  const showDiscountInfoStrip = !!(totalSaved && DiscountInfoStripExp?.switchEnabled && DiscountInfoStripExp?.experimentEnabled);


  const SavedPaymentOption = getStringFromId(VERNACULAR_STRING_IDS.SAVED_PAYMENT_OPTIONS, VERNACULAR_DEFAULT_MESSAGES.SAVED_PAYMENT_OPTIONS);
  const newPaymentMethod = getAvailablePaymentMethodOnSavedPaymentScreen({ availablePaymentMethods, isCodAvailable });
  const isNewPaymentMethodVisible = checkIsNewPaymentMethodVisibleOnScreen1({
    isExperimentEnable: NewPaymentMethodOnPaymentScreen1.experimentEnabled,
    grandTotal,
    flow,
    availablePaymentMethods,
    isCodAvailable,
    cartErrorMessage,
  });
  const isAllUpiIntentAvailableOnWeb = checkAllUpiIntentVisibilityOnWeb({
    availablePaymentMethods,
    isExperimentEnable: UpiIntentMweb.experimentEnabled && UpiIntentMweb.switchEnabled,
    cashFreePaymentGateway,
  });
  
  let {
    savedCardsDisplayed: areSavedPaymentMethodsDisplayed,
    savedMethodsAvailable,
  } = getIsSavedMethodsDisplayed(
    cartInfo,
    paymentInfo,
    upiIntentList,
    isGPayIntentAvailable,
    isAllUpiIntentAvailableOnWeb
  );  
  const isSavedPaymentVisible = flowConfig?.showPaymentView && areSavedPaymentMethodsDisplayed;

  const requestParams = {
    cartInfo,
    paymentInfo,
    isGuest,
    history,
    flow,
    deviceType,
    isOtpVerificationRequired,
    isApp,
    applyCartCharges: !!ConvenienceCharges?.experimentEnabled,
  };
  useEffect(() => {
    /* eslint-disable no-unused-vars, @typescript-eslint/no-unused-vars */
    const offers = getSavedOffer(paymentInfo, offersData);
    // setShowSavedOffers(!offers?.length);
  }, [paymentInfo, offersData]);
  const callbacks = {
    setLoading,
    setIsAutoCreateOrderLoading,
    openErrorModal,
    trackPayNowClick: trackPayNowClick,
    setIsVerifyOtpVisible,
    handleCallBackAfterVerification,
    doPaymentApi,
    history,
  };
  const doPaymentInterceptor = () => {
    doPaymentHandler(PAYMENT_MODES.COD, { giftCardConfig, walletConfig }, requestParams, callbacks);
    windowScrollToTop();
  };
  let proceedToPayVisible = false;
  let proceedToPayText = getStringFromId(
    VERNACULAR_STRING_IDS.PROCEED_TO_PAY,
    VERNACULAR_DEFAULT_MESSAGES.PROCEED_TO_PAY
  );
  const placeOrder = getStringFromId(
    VERNACULAR_STRING_IDS.PLACE_ORDER,
    VERNACULAR_DEFAULT_MESSAGES.PLACE_ORDER
  );
  // EDD vernaculars
  const defaultAddressMessage = getStringFromId(
    VERNACULAR_STRING_IDS.DEFAULT_ADDRESS_MESSAGE,
    VERNACULAR_DEFAULT_MESSAGES.DEFAULT_ADDRESS_MESSAGE
  );
  const toastDeliveryMessage = getStringFromId(
    VERNACULAR_STRING_IDS.TOAST_DELIVERY_MESSAGE,
    VERNACULAR_DEFAULT_MESSAGES.TOAST_DELIVERY_MESSAGE
  );
  // EDD states
  const [isScrollToEddElement, setIsScrollToEddElement] = useState(false);
  const [isToastVisible, setIsToastVisible] = useState(false);

  useEffect(() => {
    if (addressIdNotSame && !cartErrorMessage && cartErrorMessage?.length != 0) {
      setIsToastVisible(true);
    }
  }, [addressIdNotSame, cartErrorMessage]);
  const [isCheckButtonClickedOnToast, setIsCheckButtonClickedOnToast] = useState(false);
  const [isEddContainerExpanded, setIsEddContainerExpanded] = useState(false);
  // to help us scroll to EDD container
  const deliveryElementRef = useRef(null);
  // if addressIdDelCookie is not present, we are considering the case as anonymous pin code and message bar is shown on the top of the checkoutPage
  const isAddressIdDelCookiePresent = checkIsAddressIdDelCookiePresent();
  if (isScrollToEddElement) {
    // 100 milliseconds for accordian to open and actual ref value is found
    setTimeout(() => {
      (deliveryElementRef?.current as any)?.scrollIntoView({ behavior: "smooth" });
      if (!loading) {
        setIsScrollToEddElement(false);
      }
    }, 100);
  }
  //to hide toast visibility after 3 seconds
  setTimeout(() => {
    setIsToastVisible(false);
  }, 5000);
  // displaying wallet incase of no saved payment methods and wallet sufficient balance
  let isWalletDisplayed = areSavedPaymentMethodsDisplayed || isNewPaymentMethodVisible;
  if (
    walletBalance &&
    walletBalance > 0 &&
    walletBalance >= grandTotal &&
    grandTotal > 0 &&
    !cartErrorMessage
  ) {
    // wallet multimodal case
    isWalletDisplayed = true;
  }
  // Proceed/Place order button visibility and text handling
  if (
    !areSavedPaymentMethodsDisplayed &&
    !isWalletDisplayed &&
    !isNewPaymentMethodVisible && 
    !isGPayIntentLoading
  ) {
    proceedToPayVisible = true;
    if (grandTotal <= 0 && !isFullPaymentByGiftCard) {
      proceedToPayText = placeOrder;
    }
  }
  // EDD experiment to show the widget is expanded or collapsed form
  let expandedEstimateDeliveryToggle = checkIsExperimentEligible(
    "expandedEstimateDelivery.savedPage"
  );
  // useEffect to show EDD widget in expanded or collapsed form based on the cookie value we are getting from expandedEstimateDelivery.savedPage
  useEffect(() => {
    setIsEddContainerExpanded(!!expandedEstimateDeliveryToggle);
  }, [expandedEstimateDeliveryToggle]);
  // Function borderRadius returns different borderRadius of the paymentDetails according to the saved and All page
  let paymentDetailsBorderRadius = borderRadius();
  // Function to provide no Margin according to the payment page
  let noMarginOnNewPaymentDetail = noMargin(PAYMENT_SCREENS.SAVED);
  const priceDetailConfig = usePriceDetailsConfig({
    isGuest,
    theme,
    cartInfo,
    callbacks: {
      trackToggleAccordian: (expanded: boolean) => {
        trackPaymentDetailClick(PAYMENT_SCREENS.SAVED, expanded);
        // tracking apps price details expand
        allTrackingHandlerForApps({
          event: TRACKING_EVENTS.PRICE_DETAILS_TOOPTOP_EXPAND,
          interactionLocation: PAGE_NAMES.SAVED_PAYMENT_PAGE,
          isExpanded: expanded,
          isApp,
        });
      },
      trackInfoIconClick: (type: string) => {
        trackInfoIconClick(PAYMENT_SCREENS.SAVED, type);
      },
    },
    orderAmount: cartInfo?.grandTotal,
    codHandlingCharge,
    isCodMethodSelected,
    borderRadius: paymentDetailsBorderRadius,
    noMargin: noMarginOnNewPaymentDetail,
    initialAccordianState: true,
    platform,
  });

  const eddConfig = useEddConfig({
    isExpanded: isCheckButtonClickedOnToast || isEddContainerExpanded,
    deliveryElementRef: deliveryElementRef,
    isApp,
  });


  const NykaaWalletTitle = getStringFromId(
    VERNACULAR_STRING_IDS.NYKAA_WALLET_TITLE,
    VERNACULAR_DEFAULT_MESSAGES.NYKAA_WALLET_TITLE
  );

  const OrderInformation = getStringFromId(
    VERNACULAR_STRING_IDS.ORDER_INFORMATION,
    VERNACULAR_DEFAULT_MESSAGES.ORDER_INFORMATION
  );

  const discountText = getStringFromId(
    VERNACULAR_STRING_IDS.DYNAMIC_YOU_ARE_SAVING_AMOUNT,
    `You are saving <span class="font-medium" style="color: ${theme?.colors.positive};">₹${totalSaved}</span> on this order`,
    { totalSaved: `<span class="font-medium" style="color: ${theme?.colors.positive};">₹${totalSaved}</span>` }
  );

  const unableToFetchWalletText = getStringFromId(
    VERNACULAR_STRING_IDS.UNABLE_TO_FECTH_WALLLET,
    VERNACULAR_DEFAULT_MESSAGES.UNABLE_TO_FECTH_WALLLET
  );

  const retryButtonText = getStringFromId(
    VERNACULAR_STRING_IDS.RETRY,
    VERNACULAR_DEFAULT_MESSAGES.RETRY
  );
  /**
   * This block is for trancking event on page load
   */
  useEffect(() => {
    if (Array.isArray(products) && products?.length !== 0 && isVisible && !isPaymentInfoLoading) { // tracking should be fired after getInfo response
      const offers = getSavedOffer(paymentInfo, offersData);
      const visibleOffers = !offers?.length;
      const savedMethodString = savedMethodsAvailable.length && savedMethodsAvailable.join(", ");
      const zestVariant = ZEST_MONEY_EXPERIMENT.VISIBILITY; // 'Z_VISIBILITY experiment is always visible
      const trackingEvents = {
        page: PAGE_NAMES.SAVED_PAYMENT_PAGE,
        page_type: PAGE_TYPES.PAYMENT_PAGE,
        currency: cartInfo?.currencyCode,
        cart_value_bucket: getBucketSize(cartInfo?.grandTotal || 0),
        savedPaymentMethodsAvailable: areSavedPaymentMethodsDisplayed
          ? savedMethodString
          : NO_SAVED_METHOD,
        verificationRequired: get(walletInfo, "isVerificationRequired"),
        isScWalletEnabled: get(walletInfo, "scWalletEnabled"),
        discountApplied: cartInfo?.totalSaved,
        cartItemCount: cartInfo?.paymentDetails?.itemCount,
        cartProductCount: cartInfo?.quantity,
        zestExperiment: zestVariant,
        ab_Edd_checkout: EDD?.switchEnabled,
        cartShipping: cartInfo?.shippingCharge,
        cartSubTotal: cartInfo?.subTotal,
        cartDiscount: cartInfo?.bagDiscount,
        cartTotal: cartInfo?.grandTotal,
        cartCouponDiscount: cartInfo?.couponDiscount,
        products,
        payment_available_offers: getPaymentOffers(offersData?.paymentRules),
        flow,
        is_logged_in: !isGuest,
        price_detail_expanded: priceDetailConfig.isAccordianOpened,
        is_payment_offer_visible: visibleOffers,
        is_new_upi_intent: isAllUpiIntentAvailableOnWeb,
        is_payment_failure_enabled: failureFlowEnabled,
        isFirstLandingPageAfterCheckout: isFirstLandingPageAfterCheckout,
        is_discount_info_strip_shown: showDiscountInfoStrip,
        isNewAddressDesignEnabled: isNewAddressDesignEnabled,
        ...getCodAvailableAttributes({ availablePaymentMethods, isCodAvailable }),
      };

      trackPayment1PageLoad(trackingEvents);
      // check for retina tracking  for web  though code directly
      const retinaPage1Data = getRetinaPayment1LoadData(cartInfo, paymentInfo);
      triggerRetinaEventForWeb(isApp, retinaPage1Data);
      // page load tracking for apps
      allTrackingHandlerForApps({
        event: TRACKING_EVENTS.SAVED_PAYMENT_LOADS,
        cartInfo,
        paymentInfo,
        walletInfo,
        offersData,
        walletConfig,
        isApp,
        visibleOffers,
        failureFlowEnabled,
        isFirstLandingPageAfterCheckout,
      });

      setIsFirstLandingPageAfterCheckout(false);
      setCheckoutSuccessToFalseInDataLayer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products?.length, isVisible, isPaymentInfoLoading]);
  // }, [products?.length, loading]);  // loading was firing tracking on UPI timer screen also TODO - remove later

  /**
   * if there is no savedPayment then set payment option to NEW.
   */
  useEffect(() => {
    if (!isSavedPaymentVisible) {
      setPaymentOption(PAYMENT_OPTION.NEW);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSavedPaymentVisible]);


  return (
    <Main className={`layout vertical ${isVisible ? "visible-layer" : "hidden-layer"}`}>
      {showDiscountInfoStrip && <DiscountInfoStrip discountText={discountText} />}
      <div className="layout vertical mt15 mb10">
        {flowConfig?.address && (
          <ShippingAddressContent>
            <AddressNotMatchedMessageCard
              isAddressIdDelCookiePresent={isAddressIdDelCookiePresent}
              addressIdNotSame={addressIdNotSame}
              defaultAddressMessage={defaultAddressMessage}
              leadingIcon={getIcons("", ICONS_NAMES.EDD_INFO_ICON)}
            />
            <ShippingAddress addressBarDataTestId="txt_address_bar" />
          </ShippingAddressContent>
        )}

        {isPaymentInfoLoading && !isFailureUrl ? (
          <MainLoaderLoayoutWrapper>
            <CircularLoader />
          </MainLoaderLoayoutWrapper>
        ) : (
          <>
            {PaymentOfferRevamp.experimentEnabled && (
              <PaymentOffers
                isVisible={flowConfig?.offers && paymentScreen === PAYMENT_SCREENS.SAVED}
                offersData={offersData}
                platform={platform}
                visibleOfferBottomSheet={visibleOfferBottomSheet}
                setVisibleOfferBottomSheet={setVisibleOfferBottomSheet}
                savedPaymentPage={true}
                isAutoScroll={true}
                showCarouselDots={true}
                setLoading={setLoading}
                isApp={isApp}
              />
            )}

            {flowConfig?.wallet && (
              <>
                {isWalletDisplayed && !!walletBalance && (
                  <div className="layout vertical mt20 prl20 payment-view">
                    <h3 className="font-size-16 lh-24 font-semibold">{NykaaWalletTitle}</h3>
                    <ErrorBoundary message="Failed to load wallet section" theme={theme}>
                      <div
                        className={`${isFullPaymentByGiftCard &&
                          walletBalance >= grandTotal &&
                          "disabled-layer"}`}
                      >
                        <WalletMultiModal
                          walletConfig={walletConfig}
                          giftCardConfig={giftCardConfig}
                          orderAmount={orderAmount}
                          setIsWalletChecked={setIsWalletChecked}
                        />
                      </div>
                    </ErrorBoundary>
                  </div>
                )}
              </>
            )}
            {
              showRetryWalletTile && isRetryWalletExpEnabled && (
                <RetryWalletTile
                  nykaaWalletTitle={NykaaWalletTitle}
                  handleRetryWalletClick={handleRetryWalletClick}
                  unableToFetchWalletText={unableToFetchWalletText}
                  retryButtonText={retryButtonText}
                  theme={theme}
                />
              )
            }

            {isSavedPaymentVisible && (
              <SavedPaymentView
                timerCallback={timerCallback}
                setUpiDetails={setUpiDetails}
                isGPayIntentAvailable={isGPayIntentAvailable}
                autoPayTmCreateOrder={autoPayTmCreateOrder}
              />
            )}
            {/** This section is to show new payment method on saved payment page */}
            {isNewPaymentMethodVisible && (
              <>
                {!isSavedPaymentVisible && (
                  <SavedPaymentWrapper
                    className={`layout vertical payment-view visible-layer ${isFullPaymentByGiftCard &&
                      "disabled-layer"}`}
                    data-testid="lb_paymentMethods"
                  >
                    <h3
                      className="font-size-16 font-semibold"
                      data-testid="txt_saved_payment_option"
                    >
                      {SavedPaymentOption}
                    </h3>
                  </SavedPaymentWrapper>
                )}
                <PaymentView
                  orderAmount={orderAmount}
                  giftCardConfig={giftCardConfig}
                  walletConfig={walletConfig}
                  timerCallback={timerCallback}
                  setUpiDetails={setUpiDetails}
                  isGPayIntentAvailable={isGPayIntentAvailable}
                  paymentScreen={paymentScreen}
                  showAllPaymentMethods={showAllPaymentMethods}
                  newPaymentMethod={newPaymentMethod}
                />
              </>
            )}

            {!PaymentOfferRevamp.experimentEnabled && (
              <PaymentOffers
                isVisible={flowConfig?.offers && paymentScreen === PAYMENT_SCREENS.SAVED}
                offersData={offersData}
                platform={platform}
                visibleOfferBottomSheet={visibleOfferBottomSheet}
                setVisibleOfferBottomSheet={setVisibleOfferBottomSheet}
                savedPaymentPage={true}
                isAutoScroll={true}
                showCarouselDots={true}
                setLoading={setLoading}
                isApp={isApp}
              />
            )}

            <MorePaymentMethod
              isVisible={
                areSavedPaymentMethodsDisplayed || isWalletDisplayed || isNewPaymentMethodVisible
              }
              setPaymentScreen={setPaymentScreen}
            />
            {flowConfig?.showPriceDetails && (
              <>
                {Boolean(Object.keys(cartInfo?.paymentDetails).length) && (
                  <div className="layout vertical mrl20 pt15 payment-view">
                    <h3 className="font-size-16 mb10 font-semibold">{OrderInformation}</h3>
                  </div>
                )}
                <NewPaymentDetails
                  orderAmount={orderAmount}
                  priceDetailConfig={priceDetailConfig}
                  proceedToPayVisible={proceedToPayVisible}
                />
              </>
            )}
            {flowConfig?.edd && (
              <>
                <DeliveryToast
                  addressIdNotSame={addressIdNotSame}
                  isToastVisible={isToastVisible}
                  toastDeliveryMessage={toastDeliveryMessage}
                  setIsCheckButtonClickedOnToast={setIsCheckButtonClickedOnToast}
                  setIsScrollToEddElement={setIsScrollToEddElement}
                  setIsToastVisible={setIsToastVisible}
                />

                <DeliveryEstimate {...eddConfig} />
              </>
            )}
          </>
        )}
      </div>
      {flowConfig?.showProceedButton && proceedToPayVisible && !isPaymentInfoLoading && (
        <PlaceOrderButton
          onSubmit={doPaymentInterceptor}
          proceedToPayText={proceedToPayText}
          disabled={cartErrorMessage || isPaymentInfoLoading}
          setPaymentScreen={setPaymentScreen}
          orderAmount={orderAmount}
          isFullPaymentByGiftCard={isFullPaymentByGiftCard}
        />
      )}
      {isSavedPayment && showFallbackModeSheet && (
        <NewPaymentFailureFlow
          showFallbackModeSheet={showFallbackModeSheet}
          theme={theme}
          setShowFallbackModeSheet={setShowFallbackModeSheet}
          isGPayIntentAvailable={isGPayIntentAvailable}
          timerCallback={timerCallback}
        />
      )}
    </Main>
  );
};
export default AllSavedPaymentMethod;
